import { getFontCss, styleConstants } from '@paywithextend/components'
import React from 'react'
import { css } from 'styled-components'

type TopLevelErrorProps = {
  className?: string
  error: string | React.ReactElement
}

const TopLevelError: React.FC<TopLevelErrorProps> = ({ className, error }) => (
  <span
    className={className}
    css={css`
      ${getFontCss(
        16,
        styleConstants.colors.red,
        styleConstants.fontFamilies.medium,
      )};
    `}
  >
    {error}
  </span>
)

export default TopLevelError
